import React, { useContext, useMemo } from 'react';
import { List } from 'antd';
import { useLazyGetTemplatesQuery } from 'app/features/templates/api';
import { useLazyLoadOption } from 'app/hooks/useLazyLoadOption';
import TemplateProvider from 'app/pages/TemplateManagment/context';
import Panel from 'app/components/Layout/Panel';
import { Field, useFormikContext } from 'formik';
import classes from './Style.module.scss';

// import POItem from './PoItem';
import POItems from './EnhancedPoItem';
import { InspectionContext } from 'app/pages/BookInspection/context/InspectionContext';

export const InspectionCriteriaContext = React.createContext<any>({});

const InspectionCriteria = () => {
  const { templates, onScrollTemplates } = useContext(InspectionContext);

  return (
    <InspectionCriteriaContext.Provider
      value={{
        templates: templates,
        onLoadMore: onScrollTemplates,
      }}
    >
      <TemplateProvider>
        <Panel
          title="2. Inspection Criteria"
          className={classes.inspectionCriteria}
        >
          <Field name="inspectionPOItems">
            {({ field }) => {
              return <POItems className={classes.list} poItems={field.value} />;
              // return (
              //   <List
              //     className={classes.list}
              //     dataSource={[...field.value]}
              //     split={false}
              //     itemLayout="vertical"
              //     rowKey={(record: any) => record.id}
              //     renderItem={(record: any, index) => {
              //       return (
              //         <POItem
              //           value={record}
              //           index={index}
              //           templates={templates}
              //           inspectionRequirement={inspectionRequirement}
              //           onChange={(updated) => {
              //             setFieldValue(`inspectionPOItems[${index}]`, updated);
              //           }}
              //         />
              //       );
              //     }}
              //   ></List>
              // );
            }}
          </Field>
        </Panel>
      </TemplateProvider>
    </InspectionCriteriaContext.Provider>
  );
};

export default InspectionCriteria;
